const info = [
    {
        $schema: '../ibc_data.schema.json',
        chain_1: {
            chain_name: 'axelar',
            client_id: '07-tendermint-244',
            connection_id: 'connection-233'
        },
        chain_2: {
            chain_name: 'babylon',
            client_id: '07-tendermint-2',
            connection_id: 'connection-2'
        },
        channels: [{
                chain_1: {
                    channel_id: 'channel-175',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-2',
                    port_id: 'transfer'
                },
                ordering: 'unordered',
                version: 'ics20-1',
                tags: {
                    status: 'live'
                }
            }]
    },
    {
        $schema: '../ibc_data.schema.json',
        chain_1: {
            chain_name: 'babylon',
            client_id: '07-tendermint-0',
            connection_id: 'connection-0'
        },
        chain_2: {
            chain_name: 'cosmoshub',
            client_id: '07-tendermint-1381',
            connection_id: 'connection-1104'
        },
        channels: [{
                chain_1: {
                    channel_id: 'channel-0',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-1341',
                    port_id: 'transfer'
                },
                ordering: 'unordered',
                version: 'ics20-1',
                tags: {
                    status: 'live',
                    preferred: true
                }
            }]
    },
    {
        $schema: '../ibc_data.schema.json',
        chain_1: {
            chain_name: 'babylon',
            client_id: '07-tendermint-1',
            connection_id: 'connection-1'
        },
        chain_2: {
            chain_name: 'noble',
            client_id: '07-tendermint-147',
            connection_id: 'connection-140'
        },
        channels: [{
                chain_1: {
                    channel_id: 'channel-1',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-132',
                    port_id: 'transfer'
                },
                ordering: 'unordered',
                version: 'ics20-1',
                tags: {
                    status: 'live'
                }
            }]
    },
    {
        $schema: '../ibc_data.schema.json',
        chain_1: {
            chain_name: 'babylon',
            client_id: '07-tendermint-3',
            connection_id: 'connection-3'
        },
        chain_2: {
            chain_name: 'osmosis',
            client_id: '07-tendermint-3470',
            connection_id: 'connection-10694'
        },
        channels: [{
                chain_1: {
                    channel_id: 'channel-3',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-101635',
                    port_id: 'transfer'
                },
                ordering: 'unordered',
                version: 'ics20-1',
                tags: {
                    status: 'live',
                    preferred: true
                }
            }]
    }
];
export default info;
